export type IframeCodeTokenKind = 'tag' | 'attribute' | 'punctuation' | 'string' | 'plain';

export interface IframeCodeToken {
  kind: IframeCodeTokenKind;
  value: string;
}

const IFRAME_HTML_TOKEN = /<\/?([A-Za-z][\w:-]*)|("[^"]*"|'[^']*')|([A-Za-z_:][\w:.-]*)|([<>=])/g;

export function tokenizeIframeCode(code: string): IframeCodeToken[] {
  const tokens: IframeCodeToken[] = [];
  let index = 0;

  for (const match of code.matchAll(IFRAME_HTML_TOKEN)) {
    const matchIndex = match.index;
    if (matchIndex > index) tokens.push({ kind: 'plain', value: code.slice(index, matchIndex) });
    if (match[1]) {
      tokens.push({ kind: 'punctuation', value: match[0].slice(0, -match[1].length) });
      tokens.push({ kind: 'tag', value: match[1] });
    } else if (match[2]) {
      tokens.push({ kind: 'string', value: match[2] });
    } else if (match[3]) {
      tokens.push({ kind: 'attribute', value: match[3] });
    } else {
      tokens.push({ kind: 'punctuation', value: match[4] });
    }
    index = matchIndex + match[0].length;
  }
  if (index < code.length) tokens.push({ kind: 'plain', value: code.slice(index) });
  return tokens;
}

export function renderHighlightedIframeCode(element: HTMLElement, code: string): void {
  const fragment = document.createDocumentFragment();
  for (const token of tokenizeIframeCode(code)) {
    if (token.kind === 'plain') {
      fragment.append(document.createTextNode(token.value));
      continue;
    }
    const span = document.createElement('span');
    span.className = `iframe-code-token-${token.kind}`;
    span.textContent = token.value;
    fragment.append(span);
  }
  element.replaceChildren(fragment);
}
